import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css                             */
const StoreFranchiseIndicator = ({ className, label, ...rest }) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("store-franchise-indicator", className) }, label, /* @__PURE__ */ React.createElement(Icon, { name: "franchise", className: "store-franchise-indicator__icon" }));
export {
  StoreFranchiseIndicator as default
};
//# sourceMappingURL=StoreFranchiseIndicator.js.map
